export const createDeferredPromise = () => {
  const promise = {};
  promise.promise = new Promise((resolve, reject) => {
    promise.resolve = resolve;
    promise.reject = reject;
  });

  return promise;
};

export const createPromiseFunctionWithDelay =
  (callback, delay = 500) =>
  () => {
    return new Promise((resolve) => {
      callback();

      setTimeout(() => {
        resolve();
      }, delay);
    });
  };
